import { navigationActions } from "@tm/insurance/navigation";
import {
  getCookieByName,
  getPartnerOnClientSide,
  replaceHistory,
  replaceHistoryRemoveParams,
} from "@tm/insurance/utils";
import { PARTNER, RESPONSE_STATUS, STORAGE_KEYS } from "@tm/isomorphic-utils";
import {
  AgentAgreementModal,
  FlexComp,
  FooterSectionComp,
  FormattedText,
  H5Tag,
  LandingButton,
  ParaTag,
  SectionDividers,
  SelectCountryModalSheetV2,
  SelectCountryModalV2,
  SpanTag,
  Tags,
  TravellingToWidget,
} from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  ClientError,
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from "@tm/utility";
import { theme } from "@tm/utility/global";
import { useEffect, useRef, useState } from "react";
import DescriptionModal from "../DescriptionModal/DescriptionModal";
import WebToast from "../Toast/WebToast";

import PopularCountryComp from "./PopularCountryCompV2";
import UpcomingTrips from "./UpcomingTrips";

import { convertDateToUnix, processCountryDataFromQuery } from "../../utils";
import { ITravellingTo } from "./types";

import { getAnalytics } from "@tm/insurance/analytics";
import { trackComponentView, trackEvent } from "@tm/insurance/analytics/xdm";
import {
  getNextPageRouteDetails,
  getOrdersMyPartner,
  hitRetailConsentMyPartner,
} from "@tm/insurance/api";
import { usePartnerContext } from "@tm/static/partnerContext";
import { usePlanType } from "@tm/ui";
import { storePageTransitionStart } from "@tm/utility/analytics";
import { errorTrackEvent } from "libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents";
import SegmentModal from "../CommonLandingDT/SegmentModal";
import {
  DiscountingNote,
  TravellingToCardStyle,
  TravellingToStyle,
  TravellingToStyleWrap,
  TravelNote,
  ViewOrder,
} from "./TravelDetails.style";

const analytics = getAnalytics();

const TravellingTo = ({
  travellingToSection,
  upcomingTrip,
  calendarDatesLimit,
  travelSearchBanner,
  btnDisabledState = true,
  nextPageRoute,
  query,
  segmentId,
  countryCode,
  seoPageType,
}: ITravellingTo) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const travellingToRef = useRef<HTMLDivElement>(null);
  const device = useBreakpointV2();
  const context = usePartnerContext();
  const { type } = usePlanType();

  const {
    otherCountryTxt,
    travelNote,
    travDateTitle,
    travCountTitle,
    travCountSubtitle,
    travPurpTitle,
    travelPurposeTxt,
    popularCountryTxt,
    travelBtnTxt,
    travelSearchForm,
    travellerInfoSection,
    viewOrders,
    footerSection,
    agentAgreementSection,
    travellerBookingFor,
    travCounterTitle,
    travCountLimit,
    isInputEnabled,
    travCountError,
  } = travellingToSection || {};

  const {
    domesticProductOfferBanner,
    internationalProductOfferBanner,
    productOfferBanner,
  } = travelSearchForm || {};

  const { label, error_message, countrySelectErrMsg, placeHolder, value } =
    travelSearchForm.regionCountryList;

  const { countryData: totalCountryData, popularCountryData } =
    processCountryDataFromQuery(value || [], query, upcomingTrip, countryCode);

  const [popularCountries, setPopularCountries] = useState<any[]>(
    popularCountryData || []
  );
  const [countryData, setCountryData] = useState<any[]>(totalCountryData || []);
  const [showOtherCountry, setOtherCountry] = useState(false);
  const [countValue, setCountValue] = useState<number>(0);
  const [calenderValue, setCalenderValue] = useState<any>();
  const [showCountry, setShowCountry] = useState<any>(popularCountryData || []);
  const [isCountryError, setIsCountryError] = useState(false);
  const [descriptionTxt, setDescriptionTxt] = useState<string>("");
  const [isSelectedError, setIsSelectedError] = useState<boolean>(false);
  const [descTitle, setDescTitle] = useState<string>("");
  const [segments, setSegments] = useState<any[]>([]);
  const [segmentSelected, setSegmentSelected] = useState<any>({});
  const [travAgeRange, setTravAgeRange] = useState<any[]>([]);
  const [isSegmentModalShown, setIsSegmentModalShown] = useState(false);
  const [countrySelectToastMsg, setCountrySelectToastMsg] = useState("");
  const [isAgeRangeSelectedError, setIsAgeRangeSelectedError] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [agreementSource, setAgreementSource] = useState("");
  const [lastCalendarTypeSingle, setLastCalendarTypeSingle] = useState(false);
  const [isConsented, setIsConsented] = useState(false);
  const [isTravCountError, setIsTravCountError] = useState(false);

  const [nextPageError, setNextPageError] = useState();

  const preSelectedSegment = travelSearchForm?.segments?.value?.find(
    (item) =>
      item.id === query?.segment ||
      (seoPageType === "SEGMENT" && segmentId && item.id === segmentId) ||
      (!query?.segment && !segmentId && item.isSelected)
  );

  //set the default selected segement
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam =
      queryParams.get("segment") || (seoPageType === "SEGMENT" && segmentId);
    const segments = travelSearchForm?.segments?.value;

    if (segments) {
      const segment = segments.find(
        (item) => item.id === segParam || (!segParam && item.isSelected)
      );
      if (segment) {
        setSegmentSelected(segment);
        replaceHistory("segment", segment.id);
      }
    }
  }, []);

  //set the travelSerachForm.segments to segments
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam =
      queryParams.get("segment") || (seoPageType === "SEGMENT" && segmentId);
    if (travelSearchForm?.segments?.value) {
      if (segParam) {
        handleSegementSelect(segParam, true);
      } else {
        setSegments(travelSearchForm?.segments?.value);
      }
    }
    travelSearchForm?.segments?.value &&
      travelSearchForm?.segments?.value.length > 0 &&
      travelSearchForm?.segments?.value.forEach((item) => {
        trackComponentView({
          name: `${item.id.toLowerCase()}_segment_shown`,
          type: "plan",
        });
        if (item.isSelected) {
          trackComponentView({
            name: `${item.id.toLowerCase()}_segment_selected`,
            type: "plan",
          });
        }
      });
  }, [travelSearchForm?.segments]);

  useEffect(() => {
    if (travelSearchForm.segments) {
      trackComponentView({
        name: "special_segments_shown",
        type: "segment",
      });
      analytics?.trackLandingEvents(
        {
          actionType: "special_segments_shown",
        },
        "pageView",
        type
      );
    }
  }, [travelSearchForm.segments]);

  useEffect(() => {
    // Get query params from window.location.search (client-side) or use query prop (server-side compatible)
    let queryParams: any = query;

    if (typeof window !== "undefined" && !queryParams) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      queryParams = {
        countries: urlSearchParams.get("countries") || undefined,
        startDate: urlSearchParams.get("startDate") || undefined,
        endDate: urlSearchParams.get("endDate") || undefined,
        segment: urlSearchParams.get("segment") || undefined,
      };
    }

    // Process country data using the server-side compatible function
    const { countryData: totalCountryData, popularCountryData } =
      processCountryDataFromQuery(
        value || [],
        queryParams,
        upcomingTrip,
        countryCode
      );

    // Update history if we're using upcoming trip country code (client-side only)
    if (
      typeof window !== "undefined" &&
      !queryParams?.countries &&
      upcomingTrip?.countryCode
    ) {
      replaceHistory("countries", upcomingTrip.countryCode);
    }
    if (countryCode) {
      replaceHistory("countries", countryCode);
    }

    setCountryData(totalCountryData);
    setShowCountry([...popularCountryData]);
    setPopularCountries([...popularCountryData]);
  }, [value, upcomingTrip, travelSearchForm.segments, query]);

  useEffect(() => {
    const button = buttonRef.current;
    let viewportMargin = 16;
    let searchBarOffset = 60;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;

      const isInViewport =
        offsetTop >= 0 &&
        offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        const scrollPosition =
          offsetTop -
          window.innerHeight +
          rect.height +
          viewportMargin +
          searchBarOffset;
        window.scrollTo({ top: scrollPosition, behavior: "smooth" });
      }
    }
  }, [showCountry]);

  const populateTravelDetails = (
    countryCodes: any,
    startDate?: string,
    endDate?: string,
    travellers?: string
  ) => {
    if (countryCodes) {
      replaceHistory("countries", countryCodes);
    }
    if (startDate) {
      replaceHistory("startDate", startDate);
    }
    if (endDate) {
      replaceHistory("endDate", endDate);
    }
    if (travellers) {
      replaceHistory("travellers", travellers);
    }
  };

  const viewOrdersClickHandle = () => {
    analytics?.trackLandingEvents(
      {
        actionType: "Ins_ViewAllOrdersClicked",
      },
      "pageView",
      type
    );
    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "Ins_ViewAllOrdersClicked",
      },
    });
    if (agentAgreementSection && !isConsented) {
      setShowAgreementModal(true);
      setAgreementSource("viewOrders");
    } else {
      goToViewOrders();
    }
  };

  const goToViewOrders = async () => {
    {
      const partner = getPartnerOnClientSide();
      const requestData = {
        partner,
        query: {
          itineraryId:
            new URLSearchParams(window.location.search).get("itineraryId") ||
            "",
        },
      };
      try {
        const response = await getOrdersMyPartner(requestData);
        const { responseStatus, nextPageRouteConfig } = response;
        if (responseStatus === RESPONSE_STATUS.SUCCESS) {
          if (nextPageRouteConfig?.type === "external_link") {
            window.open(nextPageRouteConfig?.route, "_blank");
          }
        }
      } catch (err: any) {
        console.error("GET ORDER MYPARTNER FAILURE ERROR ----", { err });
        const { error } = err?.response?.data || {};
        setNextPageError(error);
      }
    }
  };

  const handleUpcomingTripClick = () => {
    replaceHistory("isUpcomingTrip", "true");
    removeSessionStorageItem(STORAGE_KEYS.TRAVELLER_DETAILS);

    analytics?.trackLandingEvents(
      {
        actionType: "upcoming_trips_clicked",
      },
      "pageView",
      type
    );
    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_clicked",
      },
    });

    const { countryCode, travelDuration, travellerNum } = upcomingTrip || {};

    const selectedCountry = countryData?.find(
      (country: any) => country.code === countryCode
    );

    populateTravelDetails(
      selectedCountry?.code,
      travelDuration?.startDate?.toString(),
      travelDuration?.endDate?.toString(),
      travellerNum?.toString()
    );

    const queryParams = new URLSearchParams(window.location.search);
    if (nextPageRoute) {
      let updatedNextPageRoute = nextPageRoute;
      if (updatedNextPageRoute.startsWith("/insurance")) {
        updatedNextPageRoute = updatedNextPageRoute.replace("/insurance", "");
      }
      navigationActions.navigateToPageByRouteName(
        `${updatedNextPageRoute}&isUpcomingTrip=true`
      );
    } else {
      const data = {
        startDate: travelDuration?.startDate?.toString(),
        endDate: travelDuration?.endDate?.toString(),
        travellers: travellerNum?.toString?.(),
        countries: [countryCode],
        isUpcomingTrip: true,
        type: queryParams.get("type") || "",
      };
      navigationActions.navigateToListing(data);
    }
  };

  const handleShowOtherCountry = () => {
    if (!showOtherCountry) {
      let countryDataArr = countryData?.map((country: any) => {
        return {
          ...country,
          isSelected: false,
          isDisabled: false,
          keywords:
            typeof country?.keywords === "string"
              ? country.keywords
                  .split(",")
                  .map((keyword: string) => keyword.trim())
              : country?.keywords,
        };
      });
      popularCountries.map((data: any) => {
        countryDataArr = countryDataArr?.map((country: any) => {
          if (country.code === data.code) {
            return {
              ...country,
              isSelected: data.isSelected,
            };
          }
          return { ...country };
        });
      });
      const isExclusiveCountrySelected = countryDataArr.find(
        (item: any) => item.isExclusiveSelection && item.isSelected
      );
      countryDataArr = countryDataArr.map((country: any) => {
        if (isExclusiveCountrySelected) {
          return country.isExclusiveSelection
            ? { ...country }
            : { ...country, isSelected: false, isDisabled: true };
        } else if (countryDataArr.some((item: any) => item.isSelected)) {
          return country.isExclusiveSelection
            ? { ...country, isDisabled: true }
            : { ...country };
        }
        return { ...country };
      });
      const selectedRegionCodes = countryDataArr
        .filter((data: any) => data.isSelected && data.type === "REGION")
        .map((data: any) => data.code);

      selectedRegionCodes?.map((code: string) => {
        countryDataArr = countryDataArr.map((country: any) => {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return { ...country, isDisabled: true };
          }
          return { ...country };
        });
      });
      analytics?.trackLandingEvents(
        {
          actionType: `Ins_CountrySelected:OtherCountry`,
        },
        "pageView",
        type
      );
      trackEvent({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_CountrySelected:OtherCountry",
        },
      });
      setCountryData(countryDataArr);
    }
    setOtherCountry(!showOtherCountry);
  };

  const handleDescriptionModal = (country: any) => {
    const clickedTime = getSessionStorageItem("clickedTime")
      ? getSessionStorageItem("clickedTime")
      : {};
    const currentTime = new Date().getTime();
    const code = country.code;
    if (
      !clickedTime[country.code] ||
      currentTime - parseInt(clickedTime[country.code], 10) >= 1800000
    ) {
      clickedTime[code] = currentTime.toString();
      setSessionStorageItem("clickedTime", {
        ...clickedTime,
      });
      return country.description;
    }
    return "";
  };

  const handlePopularCountrySelect = (code: string) => {
    setIsCountryError(false);
    let popularCountryArr = popularCountries?.map((country: any) => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return { ...country };
        }
        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }
        analytics?.trackLandingEvents(
          {
            actionType: `Ins_CountrySelected:${country.name}`,
          },
          "pageView",
          type
        );
        return { ...country, isSelected: true, isDisabled: false };
      }
      return { ...country, isDisabled: false };
    });

    const selectedCountries = popularCountryArr.filter(
      (item: any) => item.isSelected
    );

    trackEvent(
      {
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: `Ins_CountrySelected`,
        },
      },
      {
        countries: selectedCountries,
        // journeyType: "round_trip",
      }
    );

    const isExclusiveCountrySelected = popularCountryArr.find(
      (item: any) => item.isExclusiveSelection && item.isSelected
    );

    popularCountryArr = popularCountryArr.map((country: any) => {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection
          ? { ...country, isSelected: false, isDisabled: true }
          : { ...country };
      } else if (popularCountryArr.some((item: any) => item.isSelected)) {
        return country.isExclusiveSelection
          ? { ...country, isDisabled: true }
          : { ...country };
      }
      return { ...country };
    });

    const selectedPopRegionCodes = popularCountryArr
      .filter((country: any) => country.isSelected && country.type === "REGION")
      .map((country: any) => {
        return country.code;
      });

    selectedPopRegionCodes.map((item: any) => {
      popularCountryArr = popularCountryArr.map((country: any) => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return { ...country, isDisabled: true };
        }
        return { ...country };
      });
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    const countries: string = popularCountryArr
      .filter((data: any) => data.isSelected && !data.isDisabled)
      .map((data: any) => data.code)
      .join(",");
    if (countries) {
      replaceHistory("countries", countries);
    } else {
      replaceHistoryRemoveParams("countries");
    }
  };

  const onConstentClick = async () => {
    const partner = getPartnerOnClientSide();
    const requestData = { partner };
    try {
      const response = await hitRetailConsentMyPartner(requestData);
      const { responseStatus } = response;
      if (responseStatus === RESPONSE_STATUS.SUCCESS) {
        setIsConsented(true);
        setShowAgreementModal(false);
        setIsConsented(true);
        analytics?.trackLandingEvents(
          {
            actionType: `Ins_DisclaimerAccepted`,
          },
          "pageView",
          type
        );
        trackEvent({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_DisclaimerAccepted",
          },
        });
        trackEvent({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_DisclaimerAccepted",
          },
        });
        if (agreementSource === "viewOrders") {
          goToViewOrders();
        } else {
          nextPageRouteCall();
        }
      }
    } catch (err: any) {
      console.error("HIT CONSENT MYPARTNER FAILURE ERROR ----", { err });
      const { error } = err?.response?.data || {};
      setNextPageError(error);
    }
  };

  const productOfferData = () => {
    if (
      typeof window !== "undefined" &&
      (productOfferBanner ||
        domesticProductOfferBanner ||
        internationalProductOfferBanner)
    ) {
      const queryParams = new URLSearchParams(window.location.search);
      const selectedCountries = queryParams.get("countries");
      if (selectedCountries?.length) {
        if (isExclusiveCountrySelected) {
          return domesticProductOfferBanner || null;
        } else {
          return internationalProductOfferBanner || null;
        }
      } else {
        return productOfferBanner || null;
      }
    } else {
      return null;
    }
  };

  const handleSegementSelect = (
    segmentId?: string | number,
    isOnRender?: boolean
  ) => {
    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map((item) => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          replaceHistory("segment", item.id);
          analytics?.trackLandingEvents(
            {
              actionType: item.config.clickEventName,
            },
            "pageView",
            type
          );

          if (!isOnRender) {
            trackEvent({
              event_detail: {
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: item.config.clickEventName,
              },
            });
          }
          if (item?.calenderSelectionType === "SINGLE") {
            setLastCalendarTypeSingle(true);
          }
        } else {
          item.isSelected = false;
        }
        return item;
      });

      setSegments(updatedData);
    }
  };

  let toastTimeout: NodeJS.Timeout | null = null;

  const toggleSegmentModal = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");
    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && segmentSelected?.id === "STUDENT") {
      setCountrySelectToastMsg(
        "We do not have domestic student plans, please select another country to see student plans"
      );
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      segmentSelected?.modal && setIsSegmentModalShown(true);
    }
  };

  const nextPageRouteCall = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");
    const selectedPopCountries = (popularCountries ?? [])
      .filter((country) => countryCodes?.includes(country.code))
      .map((item) => item.name)
      .join("|");

    analytics?.trackLandingEvents(
      {
        actionType: "popular_country_selected",
        payload: selectedPopCountries,
      },
      "pageView",
      type
    );

    analytics?.trackLandingEvents(
      {
        actionType: "explore_plan_click",
      },
      "pageView",
      type
    );

    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "explore_plan_click",
      },
    });

    if (calenderValue && countValue && countryCodes?.length) {
      const partner = getPartnerOnClientSide();
      const requestData = {
        query: {
          itineraryId: searchParams.get("itineraryId") || "",
          type: type || "",
          source: travellerInfoSection
            ? "standalone_retail"
            : "standalone_regular",
        },
        partner,
        userSearchIntent: {
          country: countryCodes,
          departureDateTime: convertDateToUnix(calenderValue.from),
          arrivalDateTime: calenderValue.to
            ? convertDateToUnix(calenderValue.to)
            : Number(searchParams.get("endDate")),
          numberOfTravellers: countValue,
          segment: segmentSelected?.id,
          travellersData: travAgeRange?.map((item: any) => {
            return {
              travellerAgeRange: {
                min: item?.value?.[0],
                max: item?.value?.[1],
              },
            };
          }),
          travellerDetails: {
            identifier: searchParams.get("bookingFor") || "",
          },
        },
      };
      const domain =
        partner === PARTNER.GI ? ".goibibo.com" : ".makemytrip.com";

      if (travellerInfoSection && !window?.mmt_android_bridge) {
        if (getCookieByName("next_page_req")) {
          document.cookie = `next_page_req=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/`;
        }
        document.cookie = `next_page_req=${JSON.stringify(
          requestData
        )}; expires=${new Date(
          Date.now() + 15 * 60 * 1000
        ).toUTCString()}; domain=${domain}; path=/`;
        window.open(`/insurance/next-page`, "_blank");
      } else {
        try {
          const response = await getNextPageRouteDetails(requestData);
          const { responseStatus, nextPageRouteConfig } = response;
          if (responseStatus === RESPONSE_STATUS.SUCCESS) {
            if (nextPageRouteConfig?.type === "external_link") {
              if (window?.mmt_android_bridge) {
                const link = document.createElement("a");
                link.href = `${nextPageRouteConfig?.route}&open=outside`;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                window.open(nextPageRouteConfig?.route, "_blank");
              }
            } else {
              let route = nextPageRouteConfig?.route;

              if (
                route.startsWith("/insurance") &&
                !location.pathname.includes("/travel-insurance")
              ) {
                route = route.replace("/insurance", "");
              }
              navigationActions.navigateToPageByRouteName(route);
            }
          }
        } catch (err: any) {
          console.error("NEXT PAGE ROUTE FAILURE ERROR ----", { err });
          const { error } = err?.response?.data || {};
          setNextPageError(error);
        }
      }
    }
  };

  const onSubmit = async () => {
    let searchParams = new URLSearchParams(window.location.search);

    const countries = searchParams.get("countries");
    const isUpcomingTrip = searchParams.get("isUpcomingTrip");

    const countryCodes = countries?.split(",");
    let retailAgeError = false;

    if (travellerInfoSection) {
      travAgeRange?.forEach((item: any) => {
        if (!item.value || item.value.length !== 2) {
          setIsAgeRangeSelectedError(true);
          retailAgeError = true;
          return;
        }
      });
    }

    if (!countryCodes) {
      setIsCountryError(true);
      analytics?.trackLandingEvents(
        {
          actionType: "error_shown",
          payload: error_message,
        },
        "pageView",
        type
      );
      errorTrackEvent({
        error_details_list: [
          {
            message: error_message,
            source: "country_select",
            severity: "P3",
          },
        ],
      });
    }

    if (isUpcomingTrip) {
      replaceHistoryRemoveParams("isUpcomingTrip");
      searchParams.delete("isUpcomingTrip");
      removeSessionStorageItem(STORAGE_KEYS.TRAVELLER_DETAILS);
    }

    replaceHistory("segment", segmentSelected?.id);

    if (
      calenderValue &&
      countValue &&
      countryCodes?.length &&
      !retailAgeError &&
      !isTravCountError
    ) {
      if (agentAgreementSection && !isConsented) {
        setShowAgreementModal(true);
        setAgreementSource("viewPlans");
      } else {
        storePageTransitionStart("landing");
        nextPageRouteCall();
      }
    }
  };

  if (nextPageError && typeof window !== "undefined") {
    throw new ClientError(nextPageError);
  }

  const isExclusiveCountrySelected = popularCountries.find(
    (item: any) => item.isExclusiveSelection && item.isSelected
  );

  return (
    <TravellingToStyleWrap>
      {travelSearchBanner ? (
        <DiscountingNote pageTheme={context ? context : "mmt"}>
          {travelSearchBanner?.icon && (
            <img
              width="24px"
              height="24px"
              src={travelSearchBanner?.icon}
              style={{
                animation: "rotate 2s linear infinite",
              }}
              loading="eager"
            />
          )}
          <FlexComp
            flexDirection={device === "sm" ? "column" : "row"}
            margin="0px 0px 0px 4px"
            gap={device === "lg" ? "4px" : "0px"}
          >
            {travelSearchBanner?.title && (
              <FormattedText
                value={travelSearchBanner?.title}
                baseStyle={{
                  fontWeight: "bold",
                  fontSize: device === "lg" ? "16px" : "12px",
                  color: theme.greenText5,
                }}
              />
            )}
            {travelSearchBanner?.description && (
              <FormattedText
                value={travelSearchBanner?.description}
                baseStyle={{
                  fontWeight: "regular",
                  fontSize: device === "lg" ? "14px" : "12px",
                  marginTop: device === "lg" ? "2px" : "0px",
                  color: theme.greenText5,
                }}
              />
            )}
          </FlexComp>
        </DiscountingNote>
      ) : (
        travelNote &&
        travelNote.text && (
          <TravelNote>
            <FormattedText value={travelNote} />
          </TravelNote>
        )
      )}

      <TravellingToStyle>
        <TravellingToCardStyle ref={travellingToRef}>
          <FlexComp justifyContent="space-between" alignItems="center">
            <H5Tag color={theme.blackText}>
              <FormattedText value={label} />
            </H5Tag>
            {viewOrders && (
              <ViewOrder onClick={viewOrdersClickHandle}>
                <FormattedText value={viewOrders} />
              </ViewOrder>
            )}
          </FlexComp>
          <ParaTag margin="0px 0px 20px 0px">
            <FormattedText
              value={placeHolder}
              baseStyle={{ color: "#717171" }}
            />
          </ParaTag>

          {upcomingTrip && (
            <UpcomingTrips
              country={upcomingTrip?.country}
              countryCode={upcomingTrip?.countryCode}
              travelDuration={upcomingTrip?.travelDuration}
              travellerNum={upcomingTrip?.travellerNum}
              travellerTitle={upcomingTrip?.travellerTitle}
              handleUpcomingTripClick={handleUpcomingTripClick}
            />
          )}

          <SpanTag
            color={theme.greyText7}
            fontWeight="bold"
            fontSize="xs"
            margin="2px 0 8px"
          >
            {popularCountryTxt && (
              <FormattedText value={"Popular Destination"} />
            )}
          </SpanTag>

          <PopularCountryComp
            otherCountryTxt={otherCountryTxt}
            handleShowOtherCountry={handleShowOtherCountry}
            popCountry={showCountry}
            setIsSelectedError={setIsSelectedError}
            setCountrySelectToastMsg={setCountrySelectToastMsg}
            handlePopularCountrySelect={handlePopularCountrySelect}
          />

          {isCountryError && (
            <ParaTag
              color={theme.redText2}
              fontSize="xs"
              margin={device === "sm" ? "0 0 8px" : "8px 0 0"}
            >
              {error_message}
            </ParaTag>
          )}

          {device == "lg" && (
            <SectionDividers
              margin="14px -30px 14px"
              backgroundColor={"#FFFFFF"}
              xs
            />
          )}
          <TravellingToWidget
            travellerInfoSection={travellerInfoSection}
            travelPurposeTxt={travelPurposeTxt}
            travCountTitle={travCountTitle}
            travCountSubtitle={travCountSubtitle}
            travCountLimit={travCountLimit}
            travPurpTitle={travPurpTitle}
            travDateTitle={travDateTitle}
            btnDisabledState={btnDisabledState}
            countValue={countValue}
            setCountValue={setCountValue}
            travAgeRange={travAgeRange}
            setTravAgeRange={setTravAgeRange}
            calendarDatesLimit={calendarDatesLimit}
            setCalenderValue={setCalenderValue}
            setIsAgeRangeSelectedError={setIsAgeRangeSelectedError}
            upcomingTravellerNum={upcomingTrip?.travellerNum}
            upcomingFromDate={upcomingTrip?.travelDuration?.startDate}
            upcomingToDate={upcomingTrip?.travelDuration?.endDate}
            lastCalendarTypeSingle={lastCalendarTypeSingle}
            query={query}
            selectedSegment={
              segmentSelected && Object.keys(segmentSelected).length > 0
                ? segmentSelected
                : preSelectedSegment
            }
            calendarConfig={
              isExclusiveCountrySelected?.config?.calendar ||
              segmentSelected?.config ||
              preSelectedSegment?.config ||
              calendarDatesLimit
            }
            travellingToRef={travellingToRef}
            travellerBookingFor={travellerBookingFor}
            travCounterTitle={travCounterTitle}
            isInputEnabled={isInputEnabled}
            travCountError={travCountError}
            setIsTravCountError={setIsTravCountError}
          />
          {travellerInfoSection && isAgeRangeSelectedError && (
            <FlexComp
              justifyContent={device === "sm" ? "flex-start" : "right"}
              margin="-22px 0px 24px 0px"
            >
              <SpanTag fontSize="xs" color="#EB2026">
                {travellerInfoSection?.selectError ??
                  "Please select age ranges and number of travellers"}
              </SpanTag>
            </FlexComp>
          )}
          {productOfferData() && (
            <FlexComp
              justifyContent="space-between"
              alignItems="center"
              bgColor="#EFF1FF"
              borderRadius="8px"
              padding="5px 4px"
              margin="0 0 24px"
            >
              <FlexComp
                alignItems="center"
                justifyContent="flex-start"
                gap="4px"
              >
                {productOfferData()?.icon ? (
                  <img src={productOfferData()?.icon} width={24} height={24} />
                ) : (
                  <div style={{ width: "4px" }} />
                )}
                <FormattedText value={productOfferData()?.title} />
              </FlexComp>
              {
                <FlexComp alignItems="flex-end">
                  {productOfferData()?.info?.icon && (
                    <img
                      src={productOfferData()?.info?.icon}
                      width={24}
                      height={24}
                      onClick={() => {
                        window.open(productOfferData()?.info?.url, "_blank");
                      }}
                    />
                  )}
                </FlexComp>
              }
            </FlexComp>
          )}

          {travelSearchForm?.segments && (
            <FlexComp margin="0 0 24px" gap="8px" flexDirection="column">
              <ParaTag
                fontSize="xs"
                fontWeight="bold"
                textTransform="uppercase"
                color={theme.greyText}
              >
                {travelSearchForm?.segments?.label}
              </ParaTag>
              <Tags
                handleClickTab={handleSegementSelect}
                data={travelSearchForm?.segments?.value}
              />
            </FlexComp>
          )}

          {isSegmentModalShown && segmentSelected && segmentSelected?.modal && (
            <SegmentModal
              modal={segmentSelected.modal}
              onClose={() => setIsSegmentModalShown(false)}
              onPrimaryCta={onSubmit}
              onSecondaryCta={() => setIsSegmentModalShown(false)}
            />
          )}

          {travelBtnTxt && (
            <LandingButton
              buttonref={buttonRef}
              customWidth="100%"
              customTitle={travelBtnTxt}
              onClick={
                segmentSelected?.modal && travelSearchForm?.segments
                  ? toggleSegmentModal
                  : onSubmit
              }
            />
          )}

          {travelSearchForm?.disclaimer && (
            <ParaTag color={theme.greyText} margin="16px 0 0">
              {travelSearchForm.disclaimer}
            </ParaTag>
          )}
        </TravellingToCardStyle>

        {footerSection && (
          <FooterSectionComp
            icon={footerSection.icon}
            description={footerSection.description}
            background={footerSection.background}
            border={footerSection.border}
            tooltip={footerSection.tooltip}
          />
        )}

        {agentAgreementSection && (
          <AgentAgreementModal
            agentAgreementData={agentAgreementSection}
            showAgreementModal={showAgreementModal}
            setShowAgreementModal={setShowAgreementModal}
            onConstentClick={onConstentClick}
          />
        )}

        {showOtherCountry && device == "lg" && (
          <SelectCountryModalV2
            countryData={countryData}
            handleSelectCountry={handleShowOtherCountry}
            setCountryData={setCountryData}
            setShowCountry={setShowCountry}
            showCountry={showCountry}
            setIsCountryError={setIsCountryError}
            popularCountries={popularCountries}
            setPopularCountries={setPopularCountries}
            customSubTitle={placeHolder}
            countrySelectErrMsg={countrySelectErrMsg}
            handleDescriptionModal={handleDescriptionModal}
          />
        )}

        {showOtherCountry && device == "sm" && (
          <SelectCountryModalSheetV2
            countryData={countryData}
            showCountry={showCountry}
            handleSelectCountry={handleShowOtherCountry}
            setCountryData={setCountryData}
            setShowCountry={setShowCountry}
            setIsCountryError={setIsCountryError}
            popularCountries={popularCountries}
            setPopularCountries={setPopularCountries}
            customSubTitle={placeHolder}
            countrySelectErrMsg={countrySelectErrMsg}
            handleDescriptionModal={handleDescriptionModal}
          />
        )}

        {descriptionTxt && (
          <DescriptionModal
            handleDescriptionModal={() => setDescriptionTxt("")}
            value={descriptionTxt}
            title={descTitle}
          />
        )}

        {isSelectedError && device === "lg" && (
          <WebToast
            toastTxt={countrySelectErrMsg}
            position="fixed"
            height="46px"
            width="320px"
            bottom="100px"
            right="50px"
          />
        )}

        {isSelectedError && device === "sm" && (
          <WebToast
            toastTxt={countrySelectErrMsg}
            position="fixed"
            height="40px"
            bottom="10px"
          />
        )}
        {countrySelectToastMsg && (
          <WebToast
            toastTxt={countrySelectToastMsg}
            position="fixed"
            height="46px"
            width="320px"
            bottom="100px"
            right="50px"
          />
        )}
      </TravellingToStyle>
    </TravellingToStyleWrap>
  );
};

export default TravellingTo;
